// @ts-check
import Autocomplete from 'components/base/Autocomplete';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';

const LabelsAutocomplete = ({
  multipleLimit,
  labels = [],
  selectedLabels = null,
  onChange,
  width
}) => {
  const labelsDropdownOptions = labels.sort().map((label, index) => ({
    value: label,
    searchableValue: label,
    displayValue: <div key={`${index}_label}`}>{label}</div>
  }));

  return (
    // @ts-ignore
    <Autocomplete
      {...(width && { width })}
      placeholder='Select PR Labels'
      options={labelsDropdownOptions}
      multiple={true}
      multipleLimit={multipleLimit}
      multiplePlaceholder={`${selectedLabels.length} PR Labels`}
      selectedOptionValue={selectedLabels}
      disableClearable={false}
      onChange={labelNames => {
        TrackingService.logEvent(TRACKING.EVENTS.FILTER, {
          page: TRACKING.PAGES.METRICS,
          filter_name: TRACKING.FILTER.LABELS,
          label_names: labelNames
        });
        onChange(labelNames);
      }}
    />
  );
};
export default LabelsAutocomplete;
